import { create } from "zustand";

const useLanguage = create((set) => ({
  language: "",
  setLanguage: (lang) => set({ language: lang }),
}));

export default useLanguage;
